import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectSelectedReturnIds = (state) => get(state, 'selectedReturnIds', emptyArray);
export const selectCount = (state) => get(selectSelectedReturnIds(state), 'length');
